import { buildInstanceWanda } from '@/api/instances'
import { toLocalDate } from '@/utils/date'

import { PUBLIC_TYPE_FEATURE_FLAG } from './getters'

const instanceWanda = buildInstanceWanda()

const getCurrentRisk = async (store, { personId }) => {
  try {
    return await instanceWanda.get(`person/${personId}/risk/current`)
  } catch (error) {
    const errorCode = error.response?.status

    if (errorCode === 404) {
      store.commit('setError', 'NOT_FOUND')
    } else {
      store.commit('setError', 'GENERIC')
      store.dispatch(
        'errors/setError',
        { error, request: 'risk/getCurrentRisk' },
        { root: true }
      )
    }
  }
}

const getCurrentRiskDetails = async (store, { personId, riskId }) => {
  try {
    const details = await instanceWanda.get(
      `person/${personId}/risk/${riskId}/detail`
    )

    const getCode = ({ detail }) => {
      const type = detail.description.type.split('_')?.[0]
      const code = detail.description.value
      return `${type} ${code}`
    }

    const formattedDetails = details.map(detail => ({
      id: detail.caseId,
      score: detail.score,
      scoreSum: detail.scoreSum,
      label: detail.description.description,
      code: getCode({ detail })
    }))

    return formattedDetails
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'risk/getCurrentRiskDetails' },
      { root: true }
    )

    return []
  }
}

const getPublicTargetDetails = async (store, { personId }) => {
  try {
    const details = await instanceWanda.get(
      `person/${personId}/risk/target/details`
    )

    return details
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'risk/getPublicTargetDetails' },
      { root: true }
    )

    return null
  }
}

const getRiskOptions = async store => {
  try {
    const risks = await instanceWanda.get('healthcare_map/filters/risk')

    const filteredRisks = risks.filter(({ id }) => id !== 'NOT_EXIST')

    store.commit('setAllRiskClassifications', risks)
    store.commit('setRiskClassifications', filteredRisks)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'risk/getRiskOptions' },
      { root: true }
    )

    return []
  }
}

const updatePersonRisk = async (_, { personId, risk }) => {
  await instanceWanda.post('healthcare_map/risk', {
    json: {
      personId: personId,
      keyRisk: risk
    }
  })
}

const getPersonRiskHistory = async (store, { personId }) => {
  try {
    const history = await instanceWanda.get(`person/${personId}/risk/history`)

    const formattedHistory = history.map(item => ({
      ...item,
      addedAt: toLocalDate(new Date(item.addedAt))
    }))

    return formattedHistory
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'risk/getPersonRiskHistory' },
      { root: true }
    )
  }
}

const getPublicTypeFeatureFlag = store => {
  if (store.getters.showPublicType === undefined) {
    store.dispatch(
      'featureConfig/getFeatureFlagById',
      {
        id: PUBLIC_TYPE_FEATURE_FLAG
      },
      { root: true }
    )
  }
}

const clearError = store => {
  store.commit('clearError')
}

const clearRisk = store => {
  store.commit('setAllRiskClassifications', [])
  store.commit('setRiskClassifications', [])
}

export default {
  getCurrentRisk,
  getCurrentRiskDetails,
  getPublicTargetDetails,
  getRiskOptions,
  updatePersonRisk,
  getPersonRiskHistory,
  clearError,
  clearRisk,
  getPublicTypeFeatureFlag
}
